import React from 'react'
import '../styles/Logo.scss'

export const Logo: React.FC = () => {
    return (
        <div className='Logo'>
            <h1>Checklist</h1>
        </div>
    )
}